import { render, staticRenderFns } from "./SecStudy_SKMP.vue?vue&type=template&id=62d70998&scoped=true&"
import script from "./SecStudy_SKMP.vue?vue&type=script&lang=js&"
export * from "./SecStudy_SKMP.vue?vue&type=script&lang=js&"
import style0 from "./SecStudy_SKMP.vue?vue&type=style&index=0&id=62d70998&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d70998",
  null
  
)

export default component.exports